import { FC } from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { background, divider } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";

export const WeeklyStudyTimeSkeleton: FC = () => {
  return (
    <Stack
      sx={{
        bgcolor: background.white,
        borderRadius: rounded.xs,
        border: `1px solid ${divider.high}`,
        py: spacing.sm,
        px: spacing.md,
        gap: spacing.sm,
      }}
    >
      <Stack direction="row" gap={spacing.sm} flexWrap="wrap" justifyContent="center">
        <Stack gap={spacing.xxs} alignItems="center">
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="circular" width={140} height={140} />
          <Skeleton variant="text" width={160} height={20} sx={{ mt: "9px" }} />
        </Stack>

        <Stack flex={1} gap={spacing.xs}>
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} variant="rounded" height={48} sx={{ borderRadius: rounded.xs }} />
          ))}
        </Stack>
      </Stack>

      <Box sx={{ borderTop: `1px solid ${divider.high}` }} />

      <Stack gap={spacing.smd}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={140} height={20} />
          <Skeleton variant="circular" width={24} height={24} />
        </Stack>
        <Skeleton variant="rounded" height={100} sx={{ borderRadius: rounded.xs }} />
      </Stack>
    </Stack>
  );
};
